import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import React, { FunctionComponent, useRef, useState } from "react";
import { POPOVER_RIGHT_START } from "designSystem/styles/popover-positions";
import IconButton from "../button/IconButton";
import InfoPopover from "../popover/InfoPopover";

export interface InfoIconButtonProps {
	/** CSS for icon */
	className?: string;

	/** localization resource */
	res: string;

	/** parameters for localization resource for info message */
	resParams?: Array<number | string>;
};

const InfoIconButton: FunctionComponent<InfoIconButtonProps> = (props) => {
	const { className, res, resParams } = props;
	const ref = useRef(null);
	const [open, setOpen] = useState(false);

	return (
		<>
			<IconButton
				className={className}
				onClick={() => setOpen(true)}
				ref={ref}
				round
				size="small"
			>
				<InfoOutlinedIcon />
			</IconButton>
			<InfoPopover
				anchorEl={ref.current}
				onClose={() => setOpen(false)}
				open={open}
				res={res}
				resParams={resParams}
				{...POPOVER_RIGHT_START}
			/>
		</>
	);
};

export default InfoIconButton;
